var pug = require("!../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch4\u003EUnable to load similar items\u003C\u002Fh4\u003E";;return pug_html;};
module.exports = template;